import React, { useEffect, useState } from "react";
import axios from "axios";
import { Table } from "reactstrap";

const UsuariosTable = () => {
  const [usuarios, setUsuarios] = useState([]);

  useEffect(() => {
    axios
      .get("http://localhost:4000/usuarios")
      .then((response) => {
        setUsuarios(response.data);
      })
      .catch((error) => {
        console.error("Error obteniendo usuarios:", error);
      });
  }, []);

  return (
    <div>
      <h2>Lista de Usuarios</h2>
      <Table bordered>
        <thead>
          <tr>
            <th>Username</th>
            <th>Password (Hash)</th>
          </tr>
        </thead>
        <tbody>
          {usuarios.map((usuario, index) => (
            <tr key={index}>
              <td>{usuario.username}</td>
              <td>{usuario.password}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default UsuariosTable;
